export class TypeFacade {

    tfa_id: string;
    tfa_code: string;
    tfa_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.tfa_id                     = data['tfa_id'] ? data['tfa_id'] : null;
        this.tfa_code                   = data['tfa_code'] ? data['tfa_code'] : null;
        this.tfa_libelle                = data['tfa_libelle'] ? data['tfa_libelle'] : null;
    }

}
